import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  *,*::before,*::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  html {
    line-height: 1.15;
    -webkit-text-size-adjust: 100%;
    font-size:16px;
  }

  body {
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    font-family: "Poppins", sans-serif;
    overflow-x: hidden;
    width:100%;
    background-color:${({ theme }) => theme.colors.white};

    .swal2-shown{overflow-y:auto !important}

    .swal-cookie {
      width: 30% !important;

      @media(max-width: 1089px) {
        width: 90% !important;
      }
    }

  }

  .esconderMobile{
    display:block;

    @media (max-width: 600px) {
      display:none;
    }
  }

  .aparecerMobile{
    display:none;

    @media (max-width: 500px) {
      display:block;
    }
  }

.jss2 {
  margin-top: 0 !important;
}

  button{
    cursor:pointer;
  }

  ::-webkit-scrollbar {
    width: .5rem;
    height: 10px;
    background-color: ${({ theme }) => theme.colors.white};
  }

  ::-webkit-scrollbar {
    width: 10px;
    background: ${({ theme }) => theme.colors.gray};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.green};
    border-radius: 2px;
  }
/* 
  // Anti-flicker style - Google Analytics
  .async-hide { opacity: 0 !important} */

  p, h1, h2, h3, h4{
    max-width: 80ch!important;
  }

  // Cookie Consent

    .cc-window {
      box-shadow: 0px 8px 50px 0px #424a534d;
      align-items: center;
      font-size: 16px;
      font-family: Lato !important;
      justify-content: center;
    }

    .cc-message-container{
      max-width: 900px;
    }

    .cc-compliance {
      display: flex !important;
      flex-direction: row-reverse !important;
      justify-content: center !important;
      align-items: center !important;
      gap: 16px;
    }

    .cc-compliance .cc-link,
    .cc-compliance .cc-btn {
      border-radius: 50px;
      padding: 12px 16px !important;
      font-size: 16px;
      margin: 0 !important;
      height: 48px !important;
      color: #20252a !important;
      border: 1px solid #bcc8d6 !important;
      text-decoration: none !important;
      font-weight: 700;
    }

    .cc-compliance .cc-link span {
      padding: 0;
    }

    .cc-compliance :first-child {
      background-color: #00af55 !important;
      color: #fff !important;
    }

    .cc-message a.cc-link {
      color: #00af55 !important;
    }

    .cc-link.cmp-pref-link span:first-child {
      display: none;
    }

    @media screen and (max-width: 1024px) {
      .cc-window {
        flex-direction: column !important;
        padding: 16px !important;
      }
      .cc-message {
        font-size: 14px !important;
        padding: 0 !important;
        margin: 0 !important;
        text-align: center;
      }
      .cc-compliance {
        gap: 8px;
      }
      .cc-compliance .cc-link,
      .cc-compliance .cc-btn {
        font-size: 12px;
        padding: 16px 12px !important;
      }
    }
    @media screen and (max-width: 480px) {
      .cc-window {
        border-radius: 16px 16px 0 0 !important;
      }
      .cc-message {
        margin: 0 0 16px !important;
      }
    }
    `;

export default GlobalStyle;
